import type { FaireProductEntity } from "../../entity_types/product";

export const p_da7mkdqz7h: FaireProductEntity = {
  token: "p_da7mkdqz7h",
  type: "product",
  name: "P/12 Palo Santo Cone Incense",
  brandToken: "b_23nx3nnsvm",
  brandName: "Pacific Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/c050a78f7e6f66f639e4804315927c7f1b496ef20dfb0eedf55f4043c9b28cb1.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.47,
  description:
    'P/12 Palo Santo Cone Incense \nProduct Size: 2.95" X 0.98" X 4.9" Per Box\nDISPLAY: 5.9" X 5.9" X 5.9"\nMaterial: Incense\nCase Pack: 20\nA DISPLAY BOX OF 12 PACKS OF FRAGRANCE INCENSE CONES\nEACH PACK CONTAINS 15 INCENSE CONES',
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:50.832Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
